module.exports = __webpack_public_path__ + "img/1508965845.74dee803.jpg";